import { Logger, loadScript, TimeRecord } from '@kulee/helper';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var BaseChannel = /*#__PURE__ */ (function () {
    function BaseChannel() {
    }
    BaseChannel.prototype.setAdConfig = function (gameAdConfig) {
        this.gameAdConfig = gameAdConfig;
    };
    BaseChannel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('kulee/ad `init` have to be implement');
            });
        });
    };
    BaseChannel.prototype.showPrerollAd = function (_options) {
        throw new Error('kulee/ad `showPrerollAd` have to be implement');
    };
    BaseChannel.prototype.showInterstitialAd = function (_options) {
        throw new Error('kulee/ad `showInterstitialAd` have to be implement');
    };
    BaseChannel.prototype.showRewardAd = function (_options) {
        throw new Error('kulee/ad `showRewardAd` have to be implement');
    };
    return BaseChannel;
}());

// 日志前缀
var LOGGER_PREFIX = '@kulee/ad';
// 日志输出等级
var LOGGER_LEVEL = Logger.LEVEL.INFO;
// 广告渠道编码
var AD_CHANNEL_CODE = {
    APPLOVIN: 'applovin',
    GOOGLE_AFG: 'googleAFG'
};
// 没有自带测试模式的渠道
var NONE_TEST_MODE_AD_CHANNEL_CODES = [AD_CHANNEL_CODE.APPLOVIN];
// google afg广告默认配置
var DEFAULT_GOOGLE_ADCONFIG = {
    enabled: true,
    testEnabled: true,
    channel: {
        channelCode: AD_CHANNEL_CODE.GOOGLE_AFG,
        channelConfig: {
            clientId: 'ca-app-pub-123456789',
            channelId: '123456789',
            admobIntersitialSlot: 'ca-app-pub-123456789/123456789',
            admobRewardedSlot: 'ca-app-pub-123456789/123456789',
            prerollAd: {
                enabled: true
            },
            interstitialAd: {
                enabled: true,
                frequency: 30
            },
            rewardAd: {
                enabled: true,
                frequency: 0
            }
        }
    }
};
// 返回的错误码
var RESPONSE_CODES = {
    // 广告未初始化
    AD_NOT_INITIALIZED: 'AD/NOT_INITIALIZED',
    // 广告加载失败
    // 广告关闭
    AD_CLOSED: 'AD/CLOSED',
    // 免广告
    AD_FREE: 'AD/FREE',
    // 广告资源未准备就绪
    AD_RESOURCE_UNREADY: 'AD/RESOURCE_UNREADY',
    // 广告没有可用资源
    AD_RESOURCE_NA: 'AD/RESOURCE_NA',
    // 广告请求过于频繁
    AD_FREQUENTLY: 'AD/FREQUENTLY',
    // 未找到广告渠道
    AD_NO_CHANNEL: 'AD/NO_CHANNEL',
    // 未知错误
    AD_UNKNOWN_ERROR: 'AD/UNKNOWN_ERROR'
};

var logger = new Logger(LOGGER_PREFIX, LOGGER_LEVEL);

var Applovin = /*#__PURE__ */ (function (_super) {
    __extends(Applovin, _super);
    function Applovin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.channelCode = AD_CHANNEL_CODE.APPLOVIN;
        return _this;
    }
    Applovin.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, enabled, testEnabled, channelConfig, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.gameAdConfig, enabled = _a.enabled, testEnabled = _a.testEnabled, channelConfig = _a.channel.channelConfig;
                        if (!enabled || testEnabled || !channelConfig) {
                            logger.error('game ad for applovin channel config error');
                            return [2 /*return*/, false];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.Bridge.ads.init({
                                type: this.channelCode,
                                appKey: channelConfig.sdkKey
                            })];
                    case 2:
                        _b.sent();
                        logger.info('applovin init success');
                        // 加载开屏或者插屏广告
                        this.loadPrerollAd() || this.loadInterstitialAd();
                        // 加载激励广告
                        this.loadRewardAd();
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _b.sent();
                        logger.error('applovin init error', error_1);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.showPrerollAd = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, name, _b, onError, _c, onFinish, onFinishEnhance, isReady;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = options.name, name = _a === void 0 ? '' : _a, _b = options.onError, onError = _b === void 0 ? function () { } : _b, _c = options.onFinish, onFinish = _c === void 0 ? function () { } : _c;
                        onFinishEnhance = function () {
                            _this.loadInterstitialAd();
                            onFinish();
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.Bridge.ads.checkReady({
                                type: this.channelCode,
                                adsType: 1
                            })];
                    case 2:
                        isReady = (_d.sent()).isReady;
                        if (isReady) {
                            window.Bridge.ads.show({
                                type: this.channelCode,
                                showType: 1,
                                name: name,
                                callBack: function (error, payload) {
                                    if (error) {
                                        onError({
                                            code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                                        });
                                        onFinishEnhance();
                                        return;
                                    }
                                    _this.handleAdCallback(payload, __assign(__assign({}, options), { onFinish: onFinishEnhance }));
                                }
                            });
                        }
                        else {
                            onError({
                                code: RESPONSE_CODES.AD_RESOURCE_UNREADY
                            });
                            onFinishEnhance();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _d.sent();
                        onError({
                            code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                        });
                        onFinish();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.showInterstitialAd = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, name, _b, onError, _c, onFinish, onFinishEnhance, isReady;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = options.name, name = _a === void 0 ? '' : _a, _b = options.onError, onError = _b === void 0 ? function () { } : _b, _c = options.onFinish, onFinish = _c === void 0 ? function () { } : _c;
                        onFinishEnhance = function () {
                            _this.loadInterstitialAd();
                            onFinish();
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.Bridge.ads.checkReady({
                                type: this.channelCode,
                                adsType: 1
                            })];
                    case 2:
                        isReady = (_d.sent()).isReady;
                        if (isReady) {
                            window.Bridge.ads.show({
                                type: this.channelCode,
                                showType: 1,
                                name: name,
                                callBack: function (error, payload) {
                                    if (error) {
                                        onError({
                                            code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                                        });
                                        onFinishEnhance();
                                        return;
                                    }
                                    _this.handleAdCallback(payload, __assign(__assign({}, options), { onFinish: onFinishEnhance }));
                                }
                            });
                        }
                        else {
                            onError({
                                code: RESPONSE_CODES.AD_RESOURCE_UNREADY
                            });
                            onFinishEnhance();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _d.sent();
                        onError({
                            code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                        });
                        onFinish();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.showRewardAd = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, name, beforePlay, _b, onError, _c, onFinish, onFinishEnhance, isReady;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = options.name, name = _a === void 0 ? '' : _a, beforePlay = options.beforePlay, _b = options.onError, onError = _b === void 0 ? function () { } : _b, _c = options.onFinish, onFinish = _c === void 0 ? function () { } : _c;
                        onFinishEnhance = function () {
                            _this.loadRewardAd();
                            onFinish();
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.Bridge.ads.checkReady({
                                type: this.channelCode,
                                adsType: 2
                            })];
                    case 2:
                        isReady = (_d.sent()).isReady;
                        if (isReady) {
                            beforePlay(function () {
                                window.Bridge.ads.show({
                                    type: _this.channelCode,
                                    showType: 2,
                                    name: name,
                                    callBack: function (error, payload) {
                                        if (error) {
                                            onError({
                                                code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                                            });
                                            onFinishEnhance();
                                            return;
                                        }
                                        _this.handleAdCallback(payload, __assign(__assign({}, options), { onFinish: onFinishEnhance }));
                                    }
                                });
                            });
                        }
                        else {
                            onError({
                                code: RESPONSE_CODES.AD_RESOURCE_UNREADY
                            });
                            onFinishEnhance();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _d.sent();
                        onError({
                            code: RESPONSE_CODES.AD_UNKNOWN_ERROR
                        });
                        onFinish();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.loadPrerollAd = function () {
        var _a = this.gameAdConfig.channel.channelConfig.prerollAd, enabled = _a.enabled, unitId = _a.unitId;
        if (enabled) {
            this.loadInterAd(unitId);
            return true;
        }
        return false;
    };
    Applovin.prototype.loadInterstitialAd = function () {
        var _a = this.gameAdConfig.channel.channelConfig.interstitialAd, enabled = _a.enabled, unitId = _a.unitId;
        if (enabled) {
            this.loadInterAd(unitId);
        }
    };
    Applovin.prototype.loadInterAd = function (unitId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.Bridge.ads.load({
                            type: this.channelCode,
                            adsType: 1,
                            unitId: unitId
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.loadRewardAd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, enabled, unitId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.gameAdConfig.channel.channelConfig.rewardAd, enabled = _a.enabled, unitId = _a.unitId;
                        if (!enabled) return [3 /*break*/, 2];
                        return [4 /*yield*/, window.Bridge.ads.load({
                                type: this.channelCode,
                                adsType: 2,
                                unitId: unitId
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Applovin.prototype.handleAdCallback = function (payload, showAdOptions) {
        var action = payload.action, state = payload.state, isDisplay = payload.isDisplay;
        var _a = showAdOptions.onPlay, onPlay = _a === void 0 ? function () { } : _a, _b = showAdOptions.onFinish, onFinish = _b === void 0 ? function () { } : _b, _c = showAdOptions.onReward, onReward = _c === void 0 ? function () { } : _c;
        switch (action) {
            case 'video':
                // 广告开始播放
                if (state === 1) {
                    logger.log('applovin ad start to play.');
                }
                else if (state === 2) {
                    logger.log('applovin ad play end.');
                }
                break;
            case 'userReward':
                logger.log('applovin ad user can get reward.');
                onReward();
                break;
            case 'display':
                if (isDisplay === 1) {
                    logger.log('applovin ad is display.');
                    onPlay();
                }
                else if (isDisplay === 0) {
                    logger.log('applovin ad is hide.');
                    onFinish();
                }
                break;
            case 'click':
                logger.log('applovin ad is clicked.');
                break;
        }
    };
    return Applovin;
}(BaseChannel));

var GoogleAFG = /*#__PURE__ */ (function (_super) {
    __extends(GoogleAFG, _super);
    function GoogleAFG() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showRewardAdFnCache = null;
        return _this;
    }
    GoogleAFG.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, enabled, channelConfig, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.gameAdConfig, enabled = _a.enabled, channelConfig = _a.channel.channelConfig;
                        if (!enabled || !channelConfig) {
                            logger.error('game ad for googleAFG channel config error');
                            return [2 /*return*/, false];
                        }
                        if (!!window.adsbygoogle) return [3 /*break*/, 5];
                        window.adsbygoogle = window.adsbygoogle || [];
                        window.adBreak = window.adConfig = function (o) {
                            window.adsbygoogle.push(o);
                        };
                        window.adConfig({
                            preloadAdBreaks: 'on',
                            sound: 'on',
                            onReady: function () { }
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.loadAdScript()];
                    case 2:
                        _b.sent();
                        logger.log('google AFG js load success.');
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _b.sent();
                        logger.warn('google AFG js load error', error_1);
                        return [2 /*return*/, false];
                    case 4: return [3 /*break*/, 6];
                    case 5: return [2 /*return*/, true];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GoogleAFG.prototype.showPrerollAd = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var _a = options.name, name = _a === void 0 ? '' : _a, _b = options.onPlay, onPlay = _b === void 0 ? function () { } : _b, _c = options.onError, onError = _c === void 0 ? function () { } : _c, _d = options.onFinish, onFinish = _d === void 0 ? function () { } : _d;
        window.adBreak({
            type: 'preroll',
            name: name,
            beforeAd: function () {
                logger.log('google preroll ad beforeAd.');
                onPlay();
            },
            adBreakDone: function (params) {
                logger.log('google preroll ad adBreakDone.', params);
                var breakStatus = params.breakStatus;
                if (breakStatus !== 'viewed' && breakStatus !== 'dismissed') {
                    onError({
                        code: _this.handleGoogleErrorCode(breakStatus)
                    });
                }
                onFinish();
            }
        });
    };
    GoogleAFG.prototype.showInterstitialAd = function (options) {
        var _this = this;
        var _a = options.name, name = _a === void 0 ? '' : _a, type = options.type, _b = options.onPlay, onPlay = _b === void 0 ? function () { } : _b, _c = options.onError, onError = _c === void 0 ? function () { } : _c, _d = options.onFinish, onFinish = _d === void 0 ? function () { } : _d;
        if (['start', 'next', 'pause', 'browse'].indexOf(type) < 0) {
            throw new Error("parameter of type('start', 'next', 'pause' or 'browse) is require in google slot ad");
        }
        window.adBreak({
            type: type,
            name: name,
            beforeAd: function () {
                logger.log('google interstitial ad beforeAd.');
                onPlay();
            },
            afterAd: function () {
                logger.log('google interstitial ad afterAd.');
            },
            adBreakDone: function (params) {
                logger.log('google interstitial ad adBreakDone.', params);
                var breakStatus = params.breakStatus;
                if (breakStatus !== 'viewed' && breakStatus !== 'dismissed') {
                    onError({
                        code: _this.handleGoogleErrorCode(breakStatus)
                    });
                }
                onFinish();
            }
        });
    };
    GoogleAFG.prototype.showRewardAd = function (options) {
        var _this = this;
        var _a = options.name, name = _a === void 0 ? '' : _a, _b = options.beforePlay, beforePlay = _b === void 0 ? function () { } : _b, _c = options.onPlay, onPlay = _c === void 0 ? function () { } : _c, _d = options.onReward, onReward = _d === void 0 ? function () { } : _d, _e = options.onFinish, onFinish = _e === void 0 ? function () { } : _e, _f = options.onError, onError = _f === void 0 ? function () { } : _f;
        window.adBreak({
            type: 'reward',
            name: name,
            beforeReward: function (showAdFn) {
                logger.log('google reward ad beforeReward.');
                _this.showRewardAdFnCache = showAdFn;
                beforePlay(function () {
                    if (_this.showRewardAdFnCache !== null) {
                        _this.showRewardAdFnCache();
                    }
                });
            },
            beforeAd: function () {
                logger.log('google reward ad beforeAd.');
                onPlay();
            },
            adDismissed: function () {
                logger.log('google reward ad adDismissed.');
            },
            adViewed: function () {
                logger.log('google reward ad adViewed.');
                onReward();
            },
            afterAd: function () {
                logger.log('google reward ad afterAd.');
            },
            adBreakDone: function (params) {
                logger.log('google reward ad adBreakDone.', params);
                var breakStatus = params.breakStatus;
                if (breakStatus !== 'viewed' && breakStatus !== 'dismissed') {
                    onError({
                        code: _this.handleGoogleErrorCode(breakStatus)
                    });
                }
                onFinish();
                _this.showRewardAdFnCache = null;
            }
        });
    };
    /**
     * 加载google AFG所依赖JS文件
     * @param options
     * @returns
     */
    GoogleAFG.prototype.loadAdScript = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, testEnabled, _b, clientId, channelId, admobIntersitialSlot, admobRewardedSlot, url, params;
            return __generator(this, function (_c) {
                _a = this.gameAdConfig, testEnabled = _a.testEnabled, _b = _a.channel.channelConfig, clientId = _b.clientId, channelId = _b.channelId, admobIntersitialSlot = _b.admobIntersitialSlot, admobRewardedSlot = _b.admobRewardedSlot;
                url = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
                params = {
                    'data-ad-client': clientId,
                    'data-ad-channel': channelId,
                    crossorigin: 'anonymous'
                };
                testEnabled === true && (params['data-adbreak-test'] = 'on');
                admobIntersitialSlot && (params['data-admob-interstitial-slot'] = admobIntersitialSlot);
                admobRewardedSlot && (params['data-admob-rewarded-slot'] = admobRewardedSlot);
                return [2 /*return*/, loadScript(url, params)];
            });
        });
    };
    GoogleAFG.prototype.handleGoogleErrorCode = function (code) {
        switch (code) {
            case 'notReady':
                return RESPONSE_CODES.AD_RESOURCE_UNREADY;
            case 'timeout':
            case 'invalid':
            case 'noAdPreloaded':
                return RESPONSE_CODES.AD_RESOURCE_NA;
            case 'frequencyCapped':
                return RESPONSE_CODES.AD_FREQUENTLY;
            case 'error':
                return RESPONSE_CODES.AD_NO_CHANNEL;
            default:
                return RESPONSE_CODES.AD_UNKNOWN_ERROR;
        }
    };
    return GoogleAFG;
}(BaseChannel));

var KuleAd = /*#__PURE__ */ (function () {
    function KuleAd(options) {
        this.__version = '1.0.0-alpha.12';
        this.interstitialAdFrequencyKey = 'TGA-AD-I-F';
        this.rewardAdFrequencyKey = 'TGA-AD-R-F';
        // 初始化完成标识
        this.inited = false;
        this.maxDayTimes = 70;
        this.maxChannelCodes = [AD_CHANNEL_CODE.GOOGLE_AFG];
        var channel = options.channel, gameAdConfig = options.gameAdConfig;
        this.channel = channel;
        this.gameAdConfig = gameAdConfig;
        this.channel.setAdConfig(this.gameAdConfig);
    }
    KuleAd.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, enabled, _b, free, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.gameAdConfig, enabled = _a.enabled, _b = _a.free, free = _b === void 0 ? false : _b;
                        if (free || !enabled) {
                            return [2 /*return*/, (this.inited = true)];
                        }
                        _c = this;
                        return [4 /*yield*/, this.channel.init()];
                    case 1: return [2 /*return*/, (_c.inited = _d.sent())];
                }
            });
        });
    };
    KuleAd.prototype.showPrerollAd = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var _a = options.onRequest, onRequest = _a === void 0 ? function () { } : _a, _b = options.onPlay, onPlay = _b === void 0 ? function () { } : _b, _c = options.onError, onError = _c === void 0 ? function () { } : _c, _d = options.onFinish, onFinish = _d === void 0 ? function () { } : _d;
        if (!this.inited) {
            logger.warn('ad is not inited');
            onError({
                code: RESPONSE_CODES.AD_NOT_INITIALIZED,
                message: RESPONSE_CODES.AD_NOT_INITIALIZED
            });
            onFinish();
            return;
        }
        var _e = this.gameAdConfig, enabled = _e.enabled, _f = _e.free, free = _f === void 0 ? false : _f;
        var prerollAdEnabled = this.gameAdConfig.channel.channelConfig.prerollAd.enabled;
        // 处理免广告
        if (free) {
            onFinish();
            return;
        }
        // 广告配置为关闭处理
        if (!enabled || !prerollAdEnabled) {
            onError({
                code: RESPONSE_CODES.AD_CLOSED,
                message: RESPONSE_CODES.AD_CLOSED
            });
            onFinish();
            return;
        }
        // 处理当天广告次数
        if (this.maxChannelCodes.indexOf(this.gameAdConfig.channel.channelCode) >= 0 &&
            TimeRecord.getTotalRecord(this.interstitialAdFrequencyKey, this.getTodayTimestamp(), this.getNextDayTimestamp()) >
                this.maxDayTimes) {
            onFinish();
            return;
        }
        onRequest();
        return this.channel.showPrerollAd(__assign(__assign({}, options), { onPlay: function () {
                TimeRecord.add(_this.interstitialAdFrequencyKey, true);
                onPlay();
            } }));
    };
    KuleAd.prototype.showInterstitialAd = function (options) {
        var _this = this;
        var _a = options.onRequest, onRequest = _a === void 0 ? function () { } : _a, _b = options.onPlay, onPlay = _b === void 0 ? function () { } : _b, _c = options.onError, onError = _c === void 0 ? function () { } : _c, _d = options.onFinish, onFinish = _d === void 0 ? function () { } : _d;
        if (!this.inited) {
            logger.warn('ad is not inited');
            onError({
                code: RESPONSE_CODES.AD_NOT_INITIALIZED,
                message: RESPONSE_CODES.AD_NOT_INITIALIZED
            });
            onFinish();
            return;
        }
        var _e = this.gameAdConfig, enabled = _e.enabled, _f = _e.free, free = _f === void 0 ? false : _f;
        var _g = this.gameAdConfig.channel.channelConfig.interstitialAd, interstitialAdEnabled = _g.enabled, frequency = _g.frequency;
        // 处理免广告
        if (free) {
            onFinish();
            return;
        }
        // 广告配置为关闭处理
        if (!enabled || !interstitialAdEnabled) {
            onError({
                code: RESPONSE_CODES.AD_CLOSED,
                message: RESPONSE_CODES.AD_CLOSED
            });
            onFinish();
            return;
        }
        // 处理当天广告次数
        if (this.maxChannelCodes.indexOf(this.gameAdConfig.channel.channelCode) >= 0 &&
            TimeRecord.getTotalRecord(this.interstitialAdFrequencyKey, this.getTodayTimestamp(), this.getNextDayTimestamp()) >
                this.maxDayTimes) {
            onFinish();
            return;
        }
        // 广告间隔处理
        if (frequency) {
            var restTime = TimeRecord.getRestTime(this.interstitialAdFrequencyKey, frequency);
            if (restTime > 0) {
                onError({
                    code: RESPONSE_CODES.AD_FREQUENTLY,
                    message: RESPONSE_CODES.AD_FREQUENTLY,
                    payload: restTime
                });
                onFinish();
                return;
            }
        }
        onRequest();
        return this.channel.showInterstitialAd(__assign(__assign({}, options), { onPlay: function () {
                TimeRecord.add(_this.interstitialAdFrequencyKey);
                onPlay();
            } }));
    };
    KuleAd.prototype.showRewardAd = function (options) {
        var _this = this;
        var _a = options.onRequest, onRequest = _a === void 0 ? function () { } : _a, _b = options.onPlay, onPlay = _b === void 0 ? function () { } : _b, _c = options.onReward, onReward = _c === void 0 ? function () { } : _c, _d = options.onError, onError = _d === void 0 ? function () { } : _d, _e = options.onFinish, onFinish = _e === void 0 ? function () { } : _e;
        if (!this.inited) {
            logger.warn('ad is not inited');
            onError({
                code: RESPONSE_CODES.AD_NOT_INITIALIZED,
                message: RESPONSE_CODES.AD_NOT_INITIALIZED
            });
            onFinish();
            return;
        }
        var _f = this.gameAdConfig, enabled = _f.enabled, _g = _f.free, free = _g === void 0 ? false : _g;
        var _h = this.gameAdConfig.channel.channelConfig.rewardAd, rewardAdEnabled = _h.enabled, frequency = _h.frequency;
        // 处理免广告
        if (free) {
            onReward();
            onFinish();
            return;
        }
        // 广告配置为关闭处理
        if (!enabled || !rewardAdEnabled) {
            onError({
                code: RESPONSE_CODES.AD_CLOSED,
                message: RESPONSE_CODES.AD_CLOSED
            });
            onFinish();
            return;
        }
        // 广告间隔处理
        if (frequency) {
            var restTime = TimeRecord.getRestTime(this.rewardAdFrequencyKey, frequency);
            if (restTime > 0) {
                onError({
                    code: RESPONSE_CODES.AD_FREQUENTLY,
                    message: RESPONSE_CODES.AD_FREQUENTLY,
                    payload: restTime
                });
                onFinish();
                return;
            }
        }
        onRequest();
        return this.channel.showRewardAd(__assign(__assign({}, options), { onPlay: function () {
                TimeRecord.add(_this.rewardAdFrequencyKey);
                onPlay();
            } }));
    };
    KuleAd.prototype.getTodayTimestamp = function () {
        var now = new Date();
        now.setHours(0, 0, 0, 0);
        return now.getTime();
    };
    KuleAd.prototype.getNextDayTimestamp = function () {
        var now = new Date();
        now.setHours(0, 0, 0, 0);
        now.setDate(now.getDate() + 1);
        return now.getTime();
    };
    return KuleAd;
}());

export { AD_CHANNEL_CODE, Applovin, DEFAULT_GOOGLE_ADCONFIG, GoogleAFG, KuleAd, NONE_TEST_MODE_AD_CHANNEL_CODES, RESPONSE_CODES };
//# sourceMappingURL=index.js.map
